import { render } from "./CommunityFootprint.vue?vue&type=template&id=fd3ba59a"
import script from "./CommunityFootprint.vue?vue&type=script&lang=js"
export * from "./CommunityFootprint.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__